module.exports = {"name":"Rezervácia wellness, fitness","icon":"<i class='material-icons'>spa</i>","widget":{"type":"booking-wellness","initData":{}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/booking-wellness/booking-wellness.json
// module id = 303
// module chunks = 0